var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9311 0.28464C16.0428 0.19452 16.1761 0.122926 16.3232 0.0740503C16.4703 0.0251748 16.6282 0 16.7878 0C16.9473 0 17.1053 0.0251748 17.2524 0.0740503C17.3995 0.122926 17.5328 0.19452 17.6444 0.28464C18.1124 0.658667 18.119 1.26306 17.6608 1.64356L7.98479 10.6901C7.87493 10.7855 7.74161 10.8622 7.593 10.9154C7.44438 10.9687 7.28359 10.9974 7.12045 10.9998C6.95732 11.0023 6.79528 10.9783 6.64423 10.9295C6.49319 10.8807 6.35633 10.808 6.24202 10.716L0.354267 5.99728C0.127196 5.81413 0 5.56785 0 5.31135C0 5.05484 0.127196 4.80856 0.354267 4.62542C0.465944 4.53529 0.599233 4.4637 0.746329 4.41483C0.893424 4.36595 1.05137 4.34078 1.21092 4.34078C1.37047 4.34078 1.52842 4.36595 1.67551 4.41483C1.82261 4.4637 1.9559 4.53529 2.06757 4.62542L7.06186 8.6284L15.8984 0.313113C15.9086 0.303111 15.9195 0.293603 15.9311 0.28464Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e2ae15930f423ffdde98221e84b65a76.svg";
export { ForwardRef as ReactComponent };